import Footer from "../Storybook/Footer/Footer";
import { useState } from "react";
import TermsAndCondtionsDialogSwitch from "../TermAndConditionsDialog/TermsAndCondtionsDialogSwitch";
import useCMSTermsAndCondtions from "hooks/CMS/TermsAndCondtions/TermsAndCondtions";


const GeneralFooter = () => {
  const [showTnC, setShowTnC] = useState<boolean>(false);
  return (
    <>
      <TermsAndCondtionsDialogSwitch
        isOpen={showTnC}
        setIsOpen={setShowTnC}
      />
      <Footer
        colourScheme="primary"
        slimVariant
        menuItems={[
          {
            label: "Terms of use",
            onClick: () => {
              setShowTnC(true);
            },
          },
          {
            label: "Privacy Notice",
            onClick: () => {
              window.open(
                "https://www.unum.co.uk/privacy-notice",
                "Privacy-notice",
                "noopener noreferrer"
              );
            },
          },
          {
            label: "Legal Notice",
            onClick: () => {
              window.open(
                "https://www.unum.co.uk/legal-notice",
                "legal-notice",
                "noopener noreferrer"
              );
            },
          },
          {
            label: "How we use cookies",
            onClick: () => {
              window.open(
                "https://www.unum.co.uk/how-we-use-cookies",
                "cookies",
                "noopener noreferrer"
              );
            },
          },
        ]}
      />
    </>
  );
};

export default GeneralFooter;
